import styled from 'styled-components';
import {blockLine} from '../transactionCommon.css';

export * from '../transactionCommon.css';

export const blockContact = styled(blockLine)`
    text-align: end;
`;
